import React from "react";
import {connect} from "react-redux";
import {Redirect} from "react-router-dom";
import {isAuth} from "../../auth";
import "./UserDesactivated.scss";

let UserDesactivated = (props) => {
    const {user} = props;
    if (isAuth(user)) {
        return (
            <Redirect to="/" />
        )
    }
    return (
        <div className="desactivated-container">
            <h2>Usuario inactivo</h2>
            <hr></hr>
            <p>Usuario inactivo. Contacte con el administrador. </p>
        </div>
    )
}


const mapPropsToState = state => {
    return {error: state.login.error, user: state.user}
}

UserDesactivated = connect(mapPropsToState,null)(UserDesactivated);
export default UserDesactivated;